// MAP VIEW
export const MAP_LIST_WIDTH = '776px';
export const MAP_LIST_WIDTH_LARGE = '876px';
export const MAP_LIST_EVOLUTION = '916px';

// LIST VIEW
export const LISTVIEW_CONTAINER_WIDTH_FROM_1024PX = '100%';
export const LISTVIEW_CONTAINER_WIDTH = '1200px';

export const LISTVIEW_SIDEBAR_WIDTH = '260px';
export const LISTVIEW_SIDEBAR_WIDTH_LARGE = '300px';

// INDEX
export const INDEX_CONTAINER_WIDTH = '1240px';

// FORM
export const LI_HEIGHT_NUMBER = 48;
export const LI_HEIGHT = `${LI_HEIGHT_NUMBER}px`;
